var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.routeName !== 'Welcome')?_c('router-link',{attrs:{"to":{ name: 'Home' },"title":"99 Empresas"}},[_c('img',{staticClass:"toolbar__logo",attrs:{"src":_vm.miniDrawer
        ? require('@/assets/img/99icon_black.svg')
        : require('@/assets/img/99icon_white.svg'),"alt":"99 Empresas"}})]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }